import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { formatBall } from "../DienToan6x36/constants";

dayjs.extend(utc);

export default function CompactResult({ result, date, loading = false }) {
  const numbers = result?.numbers || [];

  return (
    <div className={`dt636-sidebar-kq${loading ? " is-loading" : ""}`}>
      {loading || !result ? (
        <div className="xoso-sidebar-kq__empty">
          {loading ? "" : `Chưa có KQ ${dayjs(date).format("DD/MM")}`}
        </div>
      ) : (
        <ul className="dt636-sidebar-balls">
          {numbers.map((n, i) => (
            <li key={`${n}-${i}`} className="dt636-sidebar-ball">
              {formatBall(n)}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
